import { render, staticRenderFns } from "./supplier-commitment-promotions.vue?vue&type=template&id=e1ca5da0&scoped=true"
import script from "./supplier-commitment-promotions.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-promotions.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitment-promotions.vue?vue&type=style&index=0&id=e1ca5da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ca5da0",
  null
  
)

export default component.exports